import { Banner } from "baseui/banner";
import { TP_Building } from "../types";
import { FormattedMessage, useIntl } from "react-intl";
import OnboardingAnimation from "./OnboardingAnimation";
import { styled, useStyletron } from "baseui";
import { useSetObjectValue } from "../../../../../hooks/useSetObjectValue";
import { AccessRoles, useHasRole } from "../../../../../hooks/useHasRole";

const OnboardingView: React.FC<{ showFinishButton: boolean } & TP_Building> = (props) => {
    const [css, theme] = useStyletron();
    const intl = useIntl(); 

    const [isOnboarding, setIsOnboarding, setIsOnboardingResult] = useSetObjectValue(props.id, props.resourceGroupId, "isOnboarding", props.isOnboarding);

    const canFinish = useHasRole(AccessRoles.Mapping.Write);
    const action = canFinish && props.showFinishButton ? 
    {
        label: intl.formatMessage({ id: "P_Building.FinishOnboarding", defaultMessage: "finish" }),
        onClick: () => { setIsOnboarding(false) },
    } : undefined;

    return (
        <Banner kind="info"  action={action}>
            <ContentContainer>
                <OnboardingAnimation width={'100px'}/>
                <FormattedMessage id='P_Building.IsOnboarding' defaultMessage={'Onboarding Building is in progress'}></FormattedMessage>
            </ContentContainer>
        </Banner>
    );
};

export default OnboardingView;


export const ContentContainer = styled('div',({ $theme}) => ({
    display: 'flex',
    flexDirection: 'row',
    columnGap: $theme.sizing.scale200,
    alignItems: 'center',

    flexWrap: 'nowrap',    
}));